import { Button } from '@components/common';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { useSwrResumeGetPrice } from '@hooks/useSwrApi/endpoints/user';

interface CustomConfirmModalContentProps {
  onSendSuccess: (value: boolean) => void;
  defaultPrice?: {
    price: number;
    fullPrice: number;
  };
  userSlug: string;
  doNotShowMore?: boolean;
}

export const CustomConfirmModalContent = ({
  onSendSuccess,
  defaultPrice,
  userSlug,
  doNotShowMore = false,
}: CustomConfirmModalContentProps) => {
  const { t } = useTranslation('common');

  const { data: priceList } = useSwrResumeGetPrice({
    userSlug,
    locale: 'ro',
    shouldFetch: defaultPrice?.price === undefined,
  });

  // Determine which price to use: defaultPrice takes precedence, fallback to priceList
  const priceToShow = defaultPrice ?? priceList as ApiSchema<'ResumePrice'>;

  const isPromoPrice = typeof priceToShow?.price === 'number'
    && typeof priceToShow?.fullPrice === 'number'
    && priceToShow.price < priceToShow.fullPrice;


  const toggleDoNotShowMore = () => {
    localStorage.setItem('skipUnlockConfirm', String(true));
    onSendSuccess(true);
  };

  return (
    <div className="p-5">
      <div className="mb-5 text-center">
        <span className="block text-xl font-bold">
          {t('cv.detail.contact.type')}
        </span>

        {t('global.label.unlock.price.candidate.agree')}

        <div
          className="w-full justify-center border-b py-3 text-sm text-ink-medium"
        >
          {`${t('cv.detail.contact.label')}:`}
          {isPromoPrice && (
            <span className="ml-1 text-danger line-through">
              {priceToShow?.fullPrice}
            </span>
          )}
          <span className="ml-1">
            {priceToShow?.price}
            {' '}
            {t('global.label.credits')}
          </span>
        </div>
      </div>

      <div className="text-center">
        <Button
          role="presentation"
          size="sm"
          color="secondary"
          onClick={() => onSendSuccess(true)}
          className="mr-2"
        >
          {t('global.label.unlock.candidate.info')}
        </Button>
        <Button
          role="presentation"
          size="sm"
          color="error"
          onClick={() => onSendSuccess(false)}
        >
          {t('global.label.unlock.candidate.deny')}
        </Button>
      </div>

      {doNotShowMore && (
        <div className="my-2 text-center">
          <Button
            role="presentation"
            size="sm"
            styling="none"
            onClick={toggleDoNotShowMore}
            className="ml-2 text-sm text-primary underline"
          >
            {t('global.label.do.not.show.more')}
          </Button>
        </div>
      )}
    </div>
  );
};
